import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { REQUEST_STATE } from '../../../helpers/RequestHelper';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { prefixesConstants } from '../../../modules/prefixes/actions';
import { configDefault } from '../../../core/config';
import { ServiceListUploadCollectionInterface } from './ServiceListUploadInterface';

export interface ServiceListUploadCollectionHookResponseInterface {
    serviceListUploadCollection: ServiceListUploadCollectionInterface | null;
    refreshCollectionCallback: () => void;
    getCollectionCallback: (uri: string) => void;
    state: number;
}

export const useServiceListUploadCollection = (filters: Array<Filter> = [], orders: Array<Order> = []): ServiceListUploadCollectionHookResponseInterface => {
    const dispatch = useDispatch();
    const [responseState, setResponseState] = useState<number>(REQUEST_STATE.IDLE);
    const [collection, setCollection] = useState<ServiceListUploadCollectionInterface | null>(null);

    const getCollectionCallback = useCallback(
        (uri: string) => {
            setResponseState(REQUEST_STATE.PENDING);
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(uri),
                prefixesConstants.PREFIX_UPLOAD_LIST,
                filters,
                orders,
                {
                    onSuccess: (data: ServiceListUploadCollectionInterface) => {
                        setCollection(data);
                        setResponseState(REQUEST_STATE.IDLE);
                    },
                    onError: (error: any) => {
                        setCollection(null);
                        setResponseState(REQUEST_STATE.ERROR);
                    },
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        },
        [dispatch, filters, orders]
    );

    useEffect(() => {
        if (responseState !== REQUEST_STATE.PENDING && responseState !== REQUEST_STATE.ERROR && !collection) {
            getCollectionCallback(FormGeneralHelper.getPath('/service_list_uploads', configDefault.PLATFORM_API_PREFIX));
        }
    }, [dispatch, responseState, collection, filters, orders, getCollectionCallback]);

    const resetState = (): void => {
        setCollection(null);
        setResponseState(REQUEST_STATE.IDLE);
    };

    return {
        serviceListUploadCollection: collection,
        refreshCollectionCallback: resetState,
        getCollectionCallback: getCollectionCallback,
        state: responseState,
    };
};